import React, { Component } from "react";
import $ from "jquery";
import _ from "lodash";
import "../styles/components/HeroBanner.css";

import carYear from "../assets/icons-parameters/icon-year.svg";
import carPower from "../assets/icons-parameters/icon-power.svg";
import carEngineCapacity from "../assets/icons-parameters/icon-engine.svg";
import carGear from "../assets/icons-parameters/icon-gear.svg";
import carDrivingGear from "../assets/icons-parameters/icon-drive.svg";
import acceleration from "../assets/icons-parameters/icon-acceleration.svg";
import bodyType from "../assets/icons-parameters/icon-bodytype.svg";
import engineType from "../assets/icons-parameters/icon-enginetype.svg";

export default class CarPage extends Component {
  componentDidMount() {
    $("#hero-element img").each(function() {
      var $img = $(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      $.get(
        imgURL,
        function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find("svg");

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", imgClass + " replaced-svg");
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr("xmlns:a");

          // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
          if (
            !$svg.attr("viewBox") &&
            $svg.attr("height") &&
            $svg.attr("width")
          ) {
            $svg.attr(
              "viewBox",
              "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
            );
          }

          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    });
  }

  render() {
    const {
      backgroundImage,
      carManufacture,
      headerText,
      carData,
      rentFromPriceValue
    } = this.props;

    const showAvailableButton = _.get(
      this.props,
      "availableNow.availableNowCheckbox",
      false
    );

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="hero hero-car"
              style={{ backgroundImage: `url(${backgroundImage})` }}
            >
              <div className="hero-car--header">
                <span>{carManufacture}</span>
                <h2>{headerText}</h2>
              </div>
            </div>
            <div id="hero-element" className="hero-car--parameters">
              {rentFromPriceValue !== "" && (
                <div className="hero-car--banner">
                  <p>Wynajem już od {rentFromPriceValue} zł!</p>
                  {showAvailableButton && (
                    <div>
                      <span>Dostępny od ręki</span>
                      {this.props.availableNow.availableNowFile && (
                        <a
                          href={this.props.availableNow.availableNowFile}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Zobacz specyfikację pojazdu
                        </a>
                      )}
                    </div>
                  )}
                </div>
              )}
              <ul>
                <li>
                  <span>Rok produkcji</span>
                  <div className="svg-wrapper-v2">
                    <img
                      src={carYear}
                      className="svg"
                      alt="Car parameter - carYear"
                    />
                  </div>
                  <p>{carData.year}</p>
                </li>
                <li>
                  <span>Silnik</span>
                  <div className="svg-wrapper-v2">
                    <img
                      src={carEngineCapacity}
                      className="svg"
                      alt="Car parameter - engineCapacity"
                    />
                  </div>
                  <p>{carData.engineCapacity}</p>
                </li>
                <li>
                  <span>Silnik</span>
                  <div className="svg-wrapper-v2">
                    <img
                      src={carPower}
                      className="svg"
                      alt="Car parameter - carPower"
                    />
                  </div>
                  <p>
                    {carData.enginePower}
                    KM
                  </p>
                </li>
                <li>
                  <span>Przyspieszenie</span>
                  <div className="svg-wrapper-v2">
                    <img
                      src={acceleration}
                      className="svg"
                      alt="Car parameter - acceleration"
                    />
                  </div>
                  <p>{carData.acceleration}s</p>
                </li>
                {carData.engineType.name && (
                  <li>
                    <span>Paliwo</span>
                    <div className="svg-wrapper-v2">
                      <img
                        src={engineType}
                        className="svg"
                        alt="Car parameter - engineType"
                      />
                    </div>
                    <p>{carData.engineType.name}</p>
                  </li>
                )}
                {carData.gearType.name && (
                  <li>
                    <span>Skrzynia</span>
                    <div className="svg-wrapper-v2">
                      <img
                        src={carGear}
                        className="svg"
                        alt="Car parameter - carGear"
                      />
                    </div>
                    <p>{carData.gearType.name}</p>
                  </li>
                )}
                {carData.drive.name && (
                  <li>
                    <span>Napęd</span>
                    <div className="svg-wrapper-v2">
                      <img
                        src={carDrivingGear}
                        className="svg"
                        alt="Car parameter - carDrivingGear"
                      />
                    </div>
                    <p>{carData.drive.name}</p>
                  </li>
                )}
                <li>
                  <span>Nadwozie</span>
                  <div className="svg-wrapper-v2">
                    <img
                      src={bodyType}
                      className="svg"
                      alt="Car parameter - bodyType"
                    />
                  </div>
                  <p>{carData.bodyType.name}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CarPage.defaultProps = {
  carManufacture: "",
  availableNow: {}
  // ,
  //     backgroundImage,
  //     headerText,
  //     carData,
  //     rentFromPriceValue
};
